(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const cartRoot = () => (window.Shopify?.routes?.root ? window.Shopify.routes.root : '/');

    class CartPage {
      constructor(root) {
        this.root = root;
        this.sectionId = root.dataset.sectionId;
        this.busy = false;
        this.mountFloatingCheckout();
        this.bind();
      }

      mountFloatingCheckout() {
        document.querySelectorAll('[data-cart-floating-checkout]').forEach((el) => {
          if (!this.root.contains(el)) el.remove();
        });

        const floating = this.root.querySelector('[data-cart-floating-checkout]');
        if (!floating) return;
        if (window.matchMedia('(max-width: 989px)').matches) {
          document.body.appendChild(floating);
        }
      }

      bind() {
        this.root.querySelectorAll('[data-qty-controls]').forEach((controls) => {
          const input = controls.querySelector('[data-qty-input]');
          const decrease = controls.querySelector('[data-qty-decrease]');
          const increase = controls.querySelector('[data-qty-increase]');
          const key = controls.dataset.lineKey || input?.dataset.lineKey;
          if (!input || !key) return;

          let inputTimer;
          decrease?.addEventListener('click', () => {
            const next = Math.max(0, (Number.parseInt(input.value, 10) || 0) - 1);
            input.value = String(next);
            this.changeLine(key, next);
          });

          increase?.addEventListener('click', () => {
            const next = Math.max(0, (Number.parseInt(input.value, 10) || 0) + 1);
            input.value = String(next);
            this.changeLine(key, next);
          });

          input.addEventListener('change', () => {
            clearTimeout(inputTimer);
            const next = Math.max(0, Number.parseInt(input.value, 10) || 0);
            input.value = String(next);
            inputTimer = setTimeout(() => this.changeLine(key, next), 200);
          });
        });

        this.root.querySelectorAll('[data-cart-remove]').forEach((button) => {
          button.addEventListener('click', () => {
            const key = button.dataset.lineKey;
            if (!key) return;
            this.changeLine(key, 0);
          });
        });
      }

      async changeLine(key, quantity) {
        if (this.busy) return;
        this.busy = true;
        this.root.classList.add('is-loading');

        try {
          const response = await fetch(`${cartRoot()}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: key,
              quantity: Number(quantity),
            }),
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || payload.message || 'Unable to update cart');
          }

          const cart = await response.json();
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { item_count: cart.item_count },
            })
          );
          await this.refresh();
        } catch (error) {
          console.error(error);
          if (this.root.isConnected) {
            this.busy = false;
            this.root.classList.remove('is-loading');
          }
        }
      }

      async refresh() {
        document.querySelectorAll('[data-cart-floating-checkout]').forEach((el) => el.remove());

        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.sectionId);

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error('Unable to refresh cart');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-cart-page]');
        if (!next) {
          window.location.reload();
          return;
        }

        this.root.replaceWith(next);
        initCartPages(next);
      }
    }

    const initCartPages = (scope = document) => {
      const roots = scope.matches?.('[data-cart-page]')
        ? [scope]
        : Array.from(scope.querySelectorAll('[data-cart-page]'));
      roots.forEach((root) => {
        if (root.dataset.cartReady) return;
        root.dataset.cartReady = 'true';
        new CartPage(root);
      });
    };

    initCartPages();
    document.addEventListener('shopify:section:load', (event) => initCartPages(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-page"]) return;
  try {
    
  const contactRoot = document.querySelector('.contact-page');
  const contactForm = document.querySelector('.contact-page__form');
  const contactAlert = document.querySelector('[data-contact-alert]');
  const contactFormErrors = document.querySelector('[data-contact-form-errors]');
  const submitButton = document.querySelector('[data-contact-submit]');
  const submitLabel = document.querySelector('[data-contact-submit-label]');

  const showAlert = (type, title, text) => {
    if (!contactAlert) return;

    const isSuccess = type === 'success';
    contactAlert.hidden = false;
    contactAlert.className = `contact-page__alert contact-page__alert--${type}`;
    contactAlert.innerHTML = `
      <span class="contact-page__alert-icon" aria-hidden="true">
        ${
          isSuccess
            ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 12l2 2 4-4M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.8"/></svg>'
            : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
        }
      </span>
      <div>
        <p class="contact-page__alert-title">${title}</p>
        <p class="contact-page__alert-text">${text}</p>
      </div>
    `;
    contactAlert.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  const hideAlert = () => {
    if (contactAlert) {
      contactAlert.hidden = true;
      contactAlert.innerHTML = '';
    }
    if (contactFormErrors) {
      contactFormErrors.hidden = true;
      contactFormErrors.textContent = '';
    }
  };

  const setSubmitting = (isSubmitting) => {
    if (!submitButton || !submitLabel || !contactRoot) return;
    submitButton.disabled = isSubmitting;
    submitLabel.textContent = isSubmitting
      ? contactRoot.dataset.contactSendingText
      : submitLabel.dataset.defaultLabel || submitLabel.textContent;
  };

  if (contactForm && contactRoot) {
    if (submitLabel && !submitLabel.dataset.defaultLabel) {
      submitLabel.dataset.defaultLabel = submitLabel.textContent;
    }

    contactForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      hideAlert();

      const subjectField = contactForm.querySelector('[data-contact-subject]');
      const bodyField = contactForm.querySelector('[name="contact[body]"]');
      if (!bodyField) return;

      const originalBody = bodyField.value.trim();
      if (subjectField && subjectField.value) {
        const subjectLabel = subjectField.options[subjectField.selectedIndex]?.text || subjectField.value;
        bodyField.value = `Subject: ${subjectLabel}\n\n${originalBody}`;
      }

      setSubmitting(true);

      try {
        const response = await fetch(contactForm.action || '/contact', {
          method: 'POST',
          body: new FormData(contactForm),
          credentials: 'same-origin',
          redirect: 'follow',
        });

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const errors = doc.querySelector('.errors, .error, ul.errors, .contact-page__form-errors');

        const isSuccess =
          response.url.includes('contact_posted=true') ||
          html.includes('contact_posted=true') ||
          (response.ok && !errors);

        if (isSuccess) {
          contactForm.reset();
          showAlert(
            'success',
            contactRoot.dataset.contactSuccessTitle,
            contactRoot.dataset.contactSuccessText
          );
        } else {
          const errorMessage =
            errors?.textContent.trim() || contactRoot.dataset.contactErrorText;
          if (contactFormErrors) {
            contactFormErrors.hidden = false;
            contactFormErrors.textContent = errorMessage;
          }
          showAlert('error', contactRoot.dataset.contactErrorTitle, errorMessage);
          bodyField.value = originalBody;
        }
      } catch (error) {
        console.error(error);
        showAlert(
          'error',
          contactRoot.dataset.contactErrorTitle,
          contactRoot.dataset.contactErrorText
        );
        bodyField.value = originalBody;
      } finally {
        setSubmitting(false);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel {
    constructor(root) {
      this.track = root.querySelector('[data-reviews-track]');
      this.dotsEl = root.querySelector('[data-reviews-dots]');
      this.cards = root.querySelectorAll('[data-reviews-card]');
      if (!this.track || this.cards.length === 0) return;

      this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });
      this.buildDots();
      this.updateDots();
      window.addEventListener('resize', () => {
        this.buildDots();
        this.updateDots();
      });
    }

    getPageWidth() {
      return this.track.clientWidth;
    }

    getPageCount() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxScroll <= 4) return 1;
      return Math.ceil(this.track.scrollWidth / this.track.clientWidth);
    }

    buildDots() {
      if (!this.dotsEl) return;
      const pages = this.getPageCount();
      this.dotsEl.innerHTML = '';
      if (pages <= 1) {
        this.dotsEl.hidden = true;
        return;
      }
      this.dotsEl.hidden = false;
      for (let i = 0; i < pages; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'customer-reviews__dot';
        btn.setAttribute('aria-label', `Page ${i + 1}`);
        btn.addEventListener('click', () => {
          this.track.scrollTo({ left: i * this.getPageWidth(), behavior: 'smooth' });
        });
        this.dotsEl.appendChild(btn);
      }
    }

    updateDots() {
      if (!this.dotsEl) return;
      const dots = this.dotsEl.querySelectorAll('.customer-reviews__dot');
      if (!dots.length) return;
      const page = Math.round(this.track.scrollLeft / this.getPageWidth());
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === page));
    }
  }

  document.querySelectorAll('[data-customer-reviews]').forEach((el) => new ReviewsCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  const faqSearch = document.querySelector('[data-faq-search]');
  const faqItems = document.querySelectorAll('[data-faq-item]');
  const faqEmpty = document.querySelector('[data-faq-empty]');

  if (faqSearch && faqItems.length) {
    faqSearch.addEventListener('input', () => {
      const query = faqSearch.value.trim().toLowerCase();
      let visibleCount = 0;

      faqItems.forEach((item) => {
        const text = item.textContent.toLowerCase();
        const isMatch = query === '' || text.includes(query);
        item.hidden = !isMatch;
        if (isMatch) visibleCount += 1;
      });

      if (faqEmpty) {
        faqEmpty.hidden = visibleCount > 0;
      }
    });
  }

  document.querySelectorAll('.faq-page__item[data-faq-item]').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      document.querySelectorAll('.faq-page__item[data-faq-item]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProductsCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-fp-track]');
      if (!this.track) return;

      this.timer = null;
      this.intervalMs = 5000;
      this.scrolling = false;

      root.querySelectorAll('[data-fp-prev]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.scroll(-1);
          this.restart();
        });
      });
      root.querySelectorAll('[data-fp-next]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.scroll(1);
          this.restart();
        });
      });

      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.start();
      }
    }

    columns() {
      const value = Number.parseFloat(getComputedStyle(this.root).getPropertyValue('--fp-columns'));
      return Number.isFinite(value) && value > 0 ? value : 2;
    }

    cardStep() {
      const card = this.track.querySelector('[data-product-card]');
      if (!card) return this.track.clientWidth;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    scroll(dir) {
      if (this.scrolling) return;

      const step = this.cardStep();
      const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);

      if (maxScroll <= 1) return;

      let next = this.track.scrollLeft + dir * step;

      if (dir > 0 && this.track.scrollLeft >= maxScroll - 2) {
        next = 0;
      } else if (dir < 0 && this.track.scrollLeft <= 2) {
        next = maxScroll;
      } else {
        next = Math.max(0, Math.min(next, maxScroll));
      }

      this.scrolling = true;
      this.track.scrollTo({ left: next, behavior: 'smooth' });
      window.setTimeout(() => {
        this.scrolling = false;
      }, 450);
    }

    start() {
      this.stop();
      if (this.track.scrollWidth <= this.track.clientWidth + 1) return;
      this.timer = setInterval(() => this.scroll(1), this.intervalMs);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.start();
    }
  }

  document.querySelectorAll('[data-featured-products]').forEach((el) => new FeaturedProductsCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = !mobileMenu.hidden;
      mobileMenu.hidden = isOpen;
      menuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menuToggle.setAttribute('aria-label', isOpen ? menuToggle.dataset.openLabel : menuToggle.dataset.closeLabel);
    });
  }

  const searchRoot = document.querySelector('[data-header-search]');
  const searchToggle = document.querySelector('[data-header-search-toggle]');
  const searchInput = document.querySelector('[data-header-search-input]');

  if (searchRoot && searchToggle && searchInput) {
    const setSearchOpen = (open) => {
      searchRoot.classList.toggle('is-open', open);
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        requestAnimationFrame(() => searchInput.focus());
      } else {
        searchInput.blur();
      }
    };

    searchToggle.addEventListener('click', () => {
      setSearchOpen(!searchRoot.classList.contains('is-open'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && searchRoot.classList.contains('is-open')) {
        setSearchOpen(false);
      }
    });

    document.addEventListener('click', (event) => {
      if (!searchRoot.contains(event.target) && searchRoot.classList.contains('is-open')) {
        setSearchOpen(false);
      }
    });
  }

  const cartRoot = () => (window.Shopify?.routes?.root ? window.Shopify.routes.root : '/');

  const updateCartCount = async (detail = {}) => {
    const badges = document.querySelectorAll('[data-cart-count]');
    if (!badges.length) return;

    let count = detail.item_count;
    if (typeof count !== 'number') {
      try {
        const response = await fetch(`${cartRoot()}cart.js`, {
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;
        const cart = await response.json();
        count = Number(cart.item_count) || 0;
      } catch (error) {
        console.error(error);
        return;
      }
    }

    badges.forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count <= 0;
      badge.classList.toggle('is-empty', count <= 0);
    });
  };

  document.addEventListener('cart:updated', (event) => {
    updateCartCount(event.detail || {});
  });

  document.querySelectorAll('[data-header-dropdown]').forEach((dropdown) => {
    dropdown.addEventListener('toggle', () => {
      if (!dropdown.open) return;
      document.querySelectorAll('[data-header-dropdown]').forEach((other) => {
        if (other !== dropdown) other.open = false;
      });
    });
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-header-dropdown][open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) {
        dropdown.open = false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel {
    constructor(root) {
      this.root = root;
      this.slides = root.querySelectorAll('[data-hero-slide]');
      this.dotsEl = root.querySelector('[data-hero-dots]');
      this.current = 0;
      this.timer = null;

      this.playIntro(this.slides[0]);

      if (this.slides.length <= 1) return;

      root.querySelector('[data-hero-prev]')?.addEventListener('click', () => this.goTo(this.current - 1));
      root.querySelector('[data-hero-next]')?.addEventListener('click', () => this.goTo(this.current + 1));
      this.buildDots();
      this.start();
      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
    }

    playIntro(slide) {
      if (!slide) return;

      const content = slide.querySelector('[data-hero-content]');
      if (!content) return;

      content.classList.remove('is-in');
      content.style.animation = 'none';
      void content.offsetWidth;
      content.style.animation = '';
      content.classList.add('is-in');
    }

    buildDots() {
      if (!this.dotsEl) return;
      this.dotsEl.innerHTML = '';
      this.slides.forEach((_, i) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'hero-banner__dot' + (i === 0 ? ' is-active' : '');
        btn.addEventListener('click', () => this.goTo(i));
        this.dotsEl.appendChild(btn);
      });
    }

    goTo(index) {
      const total = this.slides.length;
      this.current = ((index % total) + total) % total;
      this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.current));
      this.dotsEl?.querySelectorAll('.hero-banner__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === this.current);
      });
      this.playIntro(this.slides[this.current]);
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.goTo(this.current + 1), 7000);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.querySelectorAll('[data-hero-carousel]').forEach((el) => new HeroCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"]) return;
  try {
    
  const trackingRoot = document.querySelector('.order-tracking');
  if (trackingRoot) {
    const tabs = trackingRoot.querySelectorAll('[data-tracking-tab]');
    const panels = trackingRoot.querySelectorAll('[data-tracking-panel]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.trackingTab;

        tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.trackingPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      });
    });

    const shipmentForm = trackingRoot.querySelector('[data-shipment-form]');
    if (shipmentForm) {
      shipmentForm.addEventListener('submit', (event) => {
        event.preventDefault();
        const trackingNumber = shipmentForm.querySelector('[name="tracking_number"]')?.value.trim();
        const template = shipmentForm.dataset.trackingUrlTemplate || '';
        if (!trackingNumber || !template) return;
        const url = template.includes('TRACKING_NUMBER')
          ? template.replace('TRACKING_NUMBER', encodeURIComponent(trackingNumber))
          : `${template}${encodeURIComponent(trackingNumber)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-logos"] && !Shopify.designMode) return;
  try {
    
  const root = document.querySelector('[data-press-logos]');
  if (root) {
    const track = root.querySelector('[data-press-track]');
    const prev = root.querySelector('[data-press-prev]');
    const next = root.querySelector('[data-press-next]');
    const scrollBy = (dir) => track?.scrollBy({ left: dir * 200, behavior: 'smooth' });
    prev?.addEventListener('click', () => scrollBy(-1));
    next?.addEventListener('click', () => scrollBy(1));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const moneyFormat = (root) => root.dataset.moneyFormat || '';
    const formatMoney = (cents, format) => {
      const amount = (Number(cents) / 100).toFixed(2);
      if (!format) return `$${amount}`;
      return format.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/\{\{.*?\}\}/g, '');
    };
    const cartRoot = () => (window.Shopify?.routes?.root ? window.Shopify.routes.root : '/');
    const RECENT_KEY = 'irishtech_recently_viewed_v1';

    class ProductPage {
      constructor(root) {
        this.root = root;
        this.data = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '{}');
        this.form = root.querySelector('[data-product-form]');
        this.variantInput = root.querySelector('[data-product-variant-id]');
        this.priceCurrent = root.querySelector('[data-product-price-current]');
        this.priceCompare = root.querySelector('[data-product-price-compare]');
        this.mainImage = root.querySelector('.product-page__main-image');
        this.addBtn = root.querySelector('[data-product-add]');
        this.addLabel = root.querySelector('[data-product-add-label]');
        this.buyBtn = root.querySelector('[data-product-buy]');
        this.errorEl = root.querySelector('[data-product-error]');
        this.qtyInput = root.querySelector('[data-product-qty]');
        this.optionInputs = Array.from(root.querySelectorAll('[data-product-option-index]'));
        this.currentVariant = this.data.variants?.find((v) => String(v.id) === this.variantInput?.value) || this.data.variants?.[0];

        this.bindGallery();
        this.bindOptions();
        this.bindQty();
        this.bindForm();
        this.bindTabs();
        this.bindReadMore();
        this.bindShare();
        this.trackRecentlyViewed();
        this.renderRecentlyViewed();
      }

      bindGallery() {
        this.root.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
          thumb.addEventListener('click', () => {
            this.root.querySelectorAll('[data-product-thumb]').forEach((el) => el.classList.remove('is-active'));
            thumb.classList.add('is-active');
            if (this.mainImage && thumb.dataset.mediaSrc) {
              this.mainImage.src = thumb.dataset.mediaSrc;
              this.mainImage.srcset = '';
            }
          });
        });
      }

      bindOptions() {
        this.optionInputs.forEach((input) => {
          input.addEventListener('change', () => this.onOptionChange());
        });
      }

      selectedOptions() {
        const values = [];
        this.optionInputs.forEach((input) => {
          if (!input.checked) return;
          values[Number(input.dataset.productOptionIndex)] = input.value;
        });
        return values;
      }

      onOptionChange() {
        const selected = this.selectedOptions();
        selected.forEach((value, index) => {
          const label = this.root.querySelector(`[data-product-option-label="${index}"]`);
          if (label) label.textContent = value;
        });

        const variant = (this.data.variants || []).find((item) =>
          item.options.every((option, index) => option === selected[index])
        );
        if (!variant) {
          this.setUnavailable();
          return;
        }
        this.setVariant(variant);
      }

      setUnavailable() {
        if (this.addBtn) this.addBtn.disabled = true;
        if (this.buyBtn) this.buyBtn.disabled = true;
        if (this.addLabel) this.addLabel.textContent = this.root.dataset.unavailableLabel || 'Unavailable';
      }

      setVariant(variant) {
        this.currentVariant = variant;
        if (this.variantInput) this.variantInput.value = variant.id;
        if (this.priceCurrent) this.priceCurrent.textContent = formatMoney(variant.price, moneyFormat(this.root));
        if (this.priceCompare) {
          if (variant.compare_at_price > variant.price) {
            this.priceCompare.hidden = false;
            this.priceCompare.textContent = formatMoney(variant.compare_at_price, moneyFormat(this.root));
          } else {
            this.priceCompare.hidden = true;
            this.priceCompare.textContent = '';
          }
        }
        if (variant.featured_image && this.mainImage) {
          this.mainImage.src = variant.featured_image;
          this.mainImage.srcset = '';
          const thumb = this.root.querySelector(`[data-product-thumb][data-media-id="${variant.featured_media_id}"]`);
          if (thumb) {
            this.root.querySelectorAll('[data-product-thumb]').forEach((el) => el.classList.remove('is-active'));
            thumb.classList.add('is-active');
          }
        }
        if (this.addBtn) this.addBtn.disabled = !variant.available;
        if (this.buyBtn) this.buyBtn.disabled = !variant.available;
        if (this.addLabel) {
          this.addLabel.textContent = variant.available
            ? this.root.dataset.addLabel || 'Add to cart'
            : this.root.dataset.soldOutLabel || 'Sold out';
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      bindQty() {
        const dec = this.root.querySelector('[data-product-qty-decrease]');
        const inc = this.root.querySelector('[data-product-qty-increase]');
        dec?.addEventListener('click', () => {
          this.qtyInput.value = String(Math.max(1, (Number(this.qtyInput.value) || 1) - 1));
        });
        inc?.addEventListener('click', () => {
          this.qtyInput.value = String(Math.max(1, (Number(this.qtyInput.value) || 1) + 1));
        });
      }

      bindForm() {
        this.form?.addEventListener('submit', async (event) => {
          event.preventDefault();
          await this.addToCart(false);
        });
        this.buyBtn?.addEventListener('click', async () => {
          await this.addToCart(true);
        });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.hidden = !message;
        this.errorEl.textContent = message || '';
      }

      async addToCart(buyNow) {
        if (!this.currentVariant?.available) return;
        this.showError('');
        const quantity = Math.max(1, Number.parseInt(this.qtyInput?.value, 10) || 1);
        try {
          const response = await fetch(`${cartRoot()}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: this.currentVariant.id, quantity }),
          });
          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload.description || payload.message || 'Unable to add to cart');
          }
          if (buyNow) {
            window.location.href = `${cartRoot()}checkout`;
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } catch (error) {
          this.showError(error.message || 'Unable to add to cart');
        }
      }

      bindTabs() {
        const tabs = this.root.querySelectorAll('[data-tab]');
        const panels = this.root.querySelectorAll('[data-panel]');
        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const id = tab.dataset.tab;
            tabs.forEach((el) => {
              const active = el === tab;
              el.classList.toggle('is-active', active);
              el.setAttribute('aria-selected', active ? 'true' : 'false');
            });
            panels.forEach((panel) => {
              const active = panel.dataset.panel === id;
              panel.classList.toggle('is-active', active);
              panel.hidden = !active;
            });
          });
        });
      }

      bindReadMore() {
        const btn = this.root.querySelector('[data-product-read-more]');
        const text = this.root.querySelector('[data-product-excerpt-text]');
        if (!btn || !text) return;
        const shortText = text.textContent;
        let open = false;
        btn.addEventListener('click', () => {
          open = !open;
          text.textContent = open ? btn.dataset.full : shortText;
          btn.textContent = open
            ? this.root.dataset.readLess || 'Read less'
            : this.root.dataset.readMore || 'Read more';
        });
      }

      bindShare() {
        this.root.querySelector('[data-product-share]')?.addEventListener('click', async () => {
          const shareData = { title: this.data.title, url: window.location.href };
          try {
            if (navigator.share) await navigator.share(shareData);
            else {
              await navigator.clipboard.writeText(window.location.href);
            }
          } catch (error) {
            // user cancelled share
          }
        });

        this.root.querySelector('[data-product-wishlist]')?.addEventListener('click', (event) => {
          const button = event.currentTarget;
          const pressed = button.getAttribute('aria-pressed') === 'true';
          button.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        });
      }

      trackRecentlyViewed() {
        if (!this.data?.id) return;
        let list = [];
        try {
          list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        } catch (error) {
          list = [];
        }
        list = list.filter((item) => item.id !== this.data.id);
        list.unshift({
          id: this.data.id,
          handle: this.data.handle,
          title: this.data.title,
          url: this.data.url,
          price: this.data.price,
          image: this.data.featured_image,
        });
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8)));
      }

      renderRecentlyViewed() {
        const section = this.root.querySelector('[data-recently-viewed]');
        const grid = this.root.querySelector('[data-recently-viewed-grid]');
        if (!section || !grid) return;
        let list = [];
        try {
          list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
        } catch (error) {
          list = [];
        }
        list = list.filter((item) => item.id !== this.data.id).slice(0, 4);
        if (!list.length) return;
        section.hidden = false;
        grid.innerHTML = list
          .map((item) => {
            const price = formatMoney(item.price, moneyFormat(this.root));
            const image = item.image
              ? `<img src="${item.image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy" width="400" height="500">`
              : '';
            return `<a class="product-page__recent-card" href="${item.url}">
              <div class="product-page__recent-media">${image}</div>
              <div class="product-page__recent-title">${item.title}</div>
              <div class="product-page__recent-price">${price}</div>
            </a>`;
          })
          .join('');
      }
    }

    document.querySelectorAll('[data-product-page]').forEach((root) => {
      if (root.dataset.ppReady) return;
      root.dataset.ppReady = 'true';
      new ProductPage(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  class TrustpilotReviews {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-tp-slide]'));
      this.progress = root.querySelector('[data-tp-progress]');
      this.bar = root.querySelector('[data-tp-progress-bar]');
      this.duration = (Number(root.dataset.tpDuration) || 10) * 1000;
      this.index = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.slides.length === 0) return;

      this.show(0);
      this.play();
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        if (active) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });
      if (this.progress) this.progress.setAttribute('aria-valuenow', '0');
    }

    startProgress() {
      if (!this.bar) return;

      this.bar.classList.remove('is-running');
      this.bar.style.animation = 'none';
      void this.bar.offsetWidth;
      this.bar.style.animation = '';

      if (this.reducedMotion) {
        this.bar.style.transform = 'scaleX(1)';
        return;
      }

      this.bar.classList.add('is-running');
    }

    play() {
      this.startProgress();
      clearTimeout(this.timer);

      if (this.slides.length < 2) return;

      this.timer = setTimeout(() => this.next(), this.duration);
    }

    next() {
      const nextIndex = (this.index + 1) % this.slides.length;
      this.show(nextIndex);
      if (this.progress) this.progress.setAttribute('aria-valuenow', '100');
      this.play();
    }
  }

  document.querySelectorAll('[data-trustpilot-reviews]').forEach((el) => new TrustpilotReviews(el));

  } catch(e) { console.error(e); }
})();
})();
